export default __webpack_public_path__ + "static/media/js.a6975b72.svg";